<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <DefaultTmpl :mode="$appUtils.isMobile() ? 'mobile_search' : 'default'">
        <template v-slot:main>
            <head-utils title="Pesquisar Usuários do Sistema"/>
            <breadcrumb :items="[{label: 'Pesquisa de Usuários', path: 'users'}]"/>

            <form @submit.prevent.stop="submit">
                <ibox>
                    <template v-slot:title v-if="!$appUtils.isMobile()">
                        <h5>Filtros de Pesquisa</h5>
                    </template>

                    <template v-slot:content>
                        <div v-if="$appUtils.isDesktop() || filterMode" class="container-fluid-grid">
                            <div class="form-row" v-if="!$appUtils.isMobile() || filterMode">
                                <div class="col-md-3 form-group">
                                    <label for="usersSearchName">Nome</label>
                                    <input id="usersSearchName" type="text" class="form-control form-control-sm"
                                           v-model="search_params.name"/>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="list-card" v-for="u in search.entries" :key="u.id">
                               <span class="nm">{{u.name}} {{u.last_name}}</span>
                               <div class="em"><a :href="`mailto:${u.email}`" class="link-theme" target="_blank">{{u.email}}</a></div>
                               <div class="ph" v-html="groupPhones([u.phone1, u.phone2, u.phone3])"></div>
                               <span class="prf">{{search.profiles[u.profile]}}</span>
                               <span class="an" :class="{'c-red f-w-700': u.distance_birth}"><span v-if="!!u.date_of_birth">Aniver {{u.date_of_birth | formatDate('DD/MM')}}</span></span>

                                <div class="act">
                                    <router-link :to="{path: `/users/${u.id}/edit`}" class="btn btn-sm m-r" >
                                        <svg-icon icon="pencil-alt"/>
                                    </router-link>
                                    <button type="button" class="btn btn-sm" @click="confirmDestroy(u.id)">
                                        <svg-icon icon="trash-alt"/>
                                    </button>
                                </div>
                            </div>

                            <div ref='end_grid'>
                                <FabMenuCrud :is-open="!filterMode && isOpenFabMenu"
                                             url-new="/users/new"
                                             v-if="!filterMode"
                                             bottom-pixels="50px"
                                             @onExpand="isOpenFabMenu = !isOpenFabMenu"
                                             @onFilter="(is) => {
                                         filterMode = is;
                                         isOpenFabMenu = false;
                                         }"/>

                                <div class="t-c">
                                    <svg-icon v-if="searching" icon="sync" class="refresh load-more-crud"/>
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:footer>
                        <div class="row" v-if="filterMode || !$appUtils.isMobile()">
                            <div class="col-sm-12 t-r">
                            <span class="btn-group btn-group-sm" role="group" aria-label="Comandos de Pesquisa">
                                    <button type="button" @click="reset" class="btn btn-secondary btn-sm"><svg-icon icon="sync"/> Limpar</button>
                                    <router-link to="/users/new" class="btn btn-dark btn-sm"><svg-icon icon="plus"/> Criar Novo</router-link>
                                    <button type="submit" class="btn btn-theme-1 btn-sm"><svg-icon icon="search"/> Pesquisar</button>
                                </span>
                            </div>
                        </div>
                        <div class="row" v-if="$appUtils.isDesktop()">
                            <div class="col-sm-12">
                                <br/>
                                <Pagination
                                        :page_size="search.per_page"
                                        :current_page="search.current_page"
                                        :total_entries="search.total_entries"/>

                                <Loading :visible="searching"/>
                                <table class="table table-hover table-striped table-sm table-bordered">
                                    <thead class="thead-dark thead-center">
                                    <tr>
                                        <th>Nome</th>
                                        <th>E-mail</th>
                                        <th>Telefone(s)</th>
                                        <th>Perfil</th>
                                        <th>Aniversário</th>
                                        <th>Data Criação</th>
                                    </tr>
                                    </thead>
                                    <tbody v-if="search && search.entries">
                                    <tr v-for="u in search.entries" :key="u.id" class="line-item">
                                        <td class="v-m c-p ellipsis f-w-700" @click="edit(u.id)">{{u.name}} {{u.last_name}}</td>
                                        <td class="v-m c-p ellipsis"><a :href="`mailto:${u.email}`" class="link-theme" target="_blank">{{u.email}}</a></td>
                                        <td class="v-m c-p t-c" v-html="groupPhones([u.phone1, u.phone2, u.phone3])"></td>
                                        <td class="v-m c-p ellipsis t-c" @click="edit(u.id)">{{search.profiles[u.profile]}}</td>
                                        <td class="v-m c-p ellipsis t-c f-w-700" :class="{'c-red': u.distance_birth}" @click="edit(u.id)" :title="u.distance_birth ? `daqui ${u.distance_birth}` : ''">{{u.date_of_birth | formatDate('DD/MM')}}</td>
                                        <td class="v-m p-r o-h t-c">
                                            {{u.created_at | formatDateHourMin}}
                                            <div class="actions btn-group btn-group-xs">
                                                <button type="button"
                                                        class="btn btn-xs btn-danger"
                                                        title="Remover"
                                                        @click="confirmDestroy(u.id, $event)">
                                                    <svg-icon icon="trash-alt"/>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                                <Pagination
                                        :page_size="search.per_page"
                                        :current_page="search.current_page"
                                        :total_entries="search.total_entries"/>
                            </div>
                        </div>
                    </template>
                </ibox>
            </form>
        </template>
    </DefaultTmpl>
</template>

<script>
    import Pagination from '@/components/Pagination'
    import CRUDSearch from '@/mixins/CRUDSearch'
    import FabMenuCrud from "../../components/particles/FabMenuCrud";
    import BottomMenuMob from "../../components/particles/BottomMenuMob";
    import Loading from "../../components/particles/Loading";

    export default {
        name: "UsersSearch",
        components: {
            Loading,
            FabMenuCrud,
            Pagination,
            BottomMenuMob
        },
        mixins: [
            CRUDSearch.mount('users')
        ],
        data() {
            return {
                isOpenFabMenu: false,
            }
        },
        methods: {
            getIntersectItemListener() {
                return this.$refs.end_grid;
            },
            createSearchParams() {
                return {
                    name: ''
                }
            },
            groupPhones(phones = []) {
                if (this.$appUtils.isArray(phones) && phones.length > 0) {
                    return phones.filter(p => !!p).reduce((a,v) => {
                        return [...a, `<a href="tel:${v}" class="link-theme" target="_blank">${this.$appUtils.formatPhone(v)}</a>`]
                    }, []).join(' | ')
                }

                return null
            }
        }
    }
</script>

<style scoped lang="scss">
    .list-card {
        display: grid;
        width: 100%;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: auto;
        grid-template-areas: "nm nm"
        "em em"
        "ph ph"
        "prf an"
        "act act";
        grid-gap: 5px;
        font-size: .8em;

        padding: 5px;

        &:not(:first-child) {
            border-top: 1px solid #e7eaec;
        }

        .nm {
            grid-area: nm;
            text-align: center;
            font-weight: 700;
            font-size: 1.3em;
        }

        .em {
            grid-area: em;
            text-align: center;
        }

        .ph {
            grid-area: ph;
            text-align: center;
        }

        .prf {grid-area: prf}
        .an {
            grid-area: an;
            text-align: right;
        }

        .act {
            grid-area: act;
            text-align: right;

            .btn {
                background-color: #e5e5e5;
                svg {
                    color: #000;
                }
            }

            .m-r {
                margin-right: 5px;
            }
        }
    }
</style>
